'use client';
import React from 'react';
import Link from 'next/link';
import styles from './Breadcrumb.module.css';

// Types
export interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
  h1?: string;
  h2?: string;
  underH2?: string;
}

const ChevronRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/></svg>
);

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, className, h1, h2, underH2 }) => {
  const breadcrumbNav = (
    <nav className={`${styles.breadcrumbWrapper}${className ? ` ${className}` : ''}`} aria-label="breadcrumb">
      <ol className={styles.breadcrumbList}>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <li key={index} className={styles.breadcrumbItem}>
              {isLast ? (
                <span className={styles.currentPage}>{item.label}</span>
              ) : (
                <>
                  <Link href={item.path || '#'} style={{ textDecoration: 'none', color: 'inherit' }}>
                    <span className={styles.breadcrumbLink}>{item.label}</span>
                  </Link>
                  <span className={styles.separator}><ChevronRight /></span>
                </>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );

  if (!h1) return breadcrumbNav;

  return (
    <div className={styles.breadcrumbContainer}>
      {breadcrumbNav}
      <h1 className={styles.pageH1}>{h1}</h1>
      <div className={styles.spacer} />
      {underH2 && <p className={styles.underH2}>{underH2}</p>}
      {h2 && <h2 className={styles.pageH2}>{h2}</h2>}

    </div>
  );
};

export default Breadcrumb;